<template>
  <div class="pollingTrack-container">
    <div id="mapBox" :class="{ active: isActive }"></div>
    <div class="thumbnail-container">
      <div id="baseMap" @click="noticeBaseMap"></div>
      <div id="satelliteMap" @click="noticeSatelliteMap"></div>
      <div class="description">地图</div>
      <div class="descriptions">卫星</div>
    </div>
    <div class="pollingTrack-menu">
      <div class="track-menu">
        <el-checkbox-group v-model="checkList">
          <el-checkbox
            label="设备点位"
            @change="checkedPointMarker"
          ></el-checkbox>
          <el-checkbox
            label="车辆轨迹"
            @change="checkVehicleChange"
          ></el-checkbox>
          <el-checkbox
            label="人行轨迹"
            @change="checkCrossingChange"
          ></el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="track-show">
        <div class="menu">
          <div class="tag"></div>
          <div>设备点位</div>
        </div>
        <div class="menu">
          <div class="tag-lineY"></div>
          <div>车辆轨迹</div>
        </div>
        <div class="menu">
          <div class="tag-lineB"></div>
          <div>人行轨迹</div>
        </div>
      </div>
    </div>

    <!-- 具体设备点信息窗体 -->
    <div class="pointInfoWindow" ref="pointInfoWindow" v-show="showInfoWindow">
      <i class="delta" />
      <!-- <div class="pointInfo-title">
        <div>设备信息</div>
        <i class="el-icon-close" @click="closePointWindow" />
      </div> -->
      <div class="pointInfo-content">
        <el-row type="flex">
          <el-col style="width: 86px">设备编号:</el-col>
          <el-col>{{ listObj.deviceNum }}</el-col>
        </el-row>
        <el-row type="flex">
          <el-col style="width: 86px">检测类型:</el-col>
          <el-col>{{ listObj.type }}</el-col>
        </el-row>
        <el-row type="flex">
          <el-col style="width: 86px">建设单位:</el-col>
          <el-col>{{ listObj.constructionUnit }}</el-col>
        </el-row>
        <el-row type="flex">
          <el-col style="width: 86px">维护单位:</el-col>
          <el-col>{{ listObj.maintenanceUnit }}</el-col>
        </el-row>
        <el-row type="flex">
          <el-col style="width: 86px">设备经度:</el-col>
          <el-col>{{ lng }}</el-col>
        </el-row>
        <el-row type="flex">
          <el-col style="width: 86px">设备纬度:</el-col>
          <el-col>{{ lat }}</el-col>
        </el-row>
      </div>
      <!-- <div class="pointInfo-footer">
        <el-button type="text" @click="showDialog">全景图</el-button>
      </div> -->
    </div>
  </div>
</template>

<script>
import AMap from "AMap";
import data from "../views/OtherServices/GeologicalMonitor/data.json";
export default {
  name: "PollingTrack",
  props: {
    location: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      map: null,
      baseMap: null,
      satelliteMap: null,
      satellite: null,
      checkList: ["设备点位", "车辆轨迹", "人行轨迹"],
      vehiclePolyline: null,
      crossingPolyline: null,
      markerPoint: null,
      markerPointAll: [],
      crossingDriving: null, // 路线规划插件
      vehicleDriving: null,
      lnglats: [],
      pointInfoWindow: null,
      showInfoWindow: false,
      listObj: {},
      showDialog: false,
      lng: null,
      lat: null,
      scale: null,
      isActive: false,
    };
  },
  computed: {
    myLocation: function () {
      return this.location;
    },
  },
  mounted() {
    this.initMap();
    this.$nextTick(() => {
      this.baseMap.setCenter(this.location);
      this.satelliteMap.setCenter(this.location);
      this.satellite.hide();
      if (this.checkList.length === 3) {
        this.map.add(this.markerPointAll);
        this.checkVehicleChange(true);
        this.checkCrossingChange(true);
      } else {
        this.vehicleDriving.clear();
        this.crossingDriving.clear();
        this.map.remove(this.vehiclePolyline);
        this.map.remove(this.crossingPolyline);
      }
    });
    this.addPointMarkers();
    this.toChangeLocation();
  },
  watch: {
    myLocation: {
      handler(val) {
        // 直接 this.map 是 null
        this.$nextTick(() => {
          //   console.log(this.map, val);
          this.map.setCenter(val);
        });
      },
      deep: true,
      immediate: true,
    },
    listObj(val) {
      // console.log(val);
      this.lng = val.location[0].toFixed(6);
      this.lat = val.location[1].toFixed(6);
    },
  },
  methods: {
    // 设备点
    checkedPointMarker(val) {
      if (val) {
        this.map.add(this.markerPointAll);
      } else {
        this.map.remove(this.markerPointAll);
      }
    },
    // 车辆轨迹
    checkVehicleChange(val) {
      if (val) {
        // 画路线轨迹;
        this.drawVehicleGuidelines(
          data.vehicleTrack.lnglat,
          data.vehicleTrack.destLnglat,
          "#ff7800"
        );
      } else {
        this.vehicleDriving.clear();
        this.map.remove(this.vehiclePolyline);
      }
    },
    // 人行轨迹
    checkCrossingChange(val) {
      if (val) {
        // 画路线轨迹;
        this.drawCrossingGuidelines(
          data.crossingTrack.lnglat,
          data.crossingTrack.destLnglat,
          "#00f2ff"
        );
      } else {
        this.crossingDriving.clear();
        this.map.remove(this.crossingPolyline);
      }
    },
    // 根据起始点人行路线
    drawCrossingGuidelines(start, end, color) {
      // 根据起终点画线
      this.crossingDriving.search(start, end, () => {
        // 绘制路线节点，点连成线
        let path = this.lnglats;
        // console.log(path);
        // 创建折线实例
        this.crossingPolyline = new AMap.Polyline({
          map: this.map, // 显示在此地图上
          path: path,
          isOutline: false,
          borderWeight: 4, // 线条宽度，默认为 1
          strokeColor: color, // 线条颜色
          lineJoin: "round", // 折线拐点连接处样式
        });
      });
    },

    // google 坐标转换成高德地图坐标
    toChangeLocation() {
      for (var i = 0; i < data.crossingTrack.dragonData.points.length; i++) {
        let steps = data.crossingTrack.dragonData.points[i];
        AMap.convertFrom(steps, "gps", (status, result) => {
          if (result.info === "ok") {
            // console.log(result);
            this.lnglats.push(result.locations[0]); // Array.<LngLat>
          }
        });
      }
    },
    // 关闭设备信息窗体
    closePointWindow() {
      console.log("close point window");
      this.showInfoWindow = false;
      this.pointInfoWindow.close();
    },

    // 根据起始点车辆路线
    drawVehicleGuidelines(start, end, color) {
      // 根据起终点画线
      this.crossingDriving.search(start, end, () => {
        // 绘制路线节点，点连成线
        let path = [];
        for (let i = 0; i < data.vehicleTrack.dragonData.points.length; i++) {
          // 先遍历坐标数组，将每一个坐标点存在path中
          let steps = data.vehicleTrack.dragonData.points[i];
          path.push(steps);
        }
        // console.log(path);
        // 创建折线实例
        this.vehiclePolyline = new AMap.Polyline({
          map: this.map, // 显示在此地图上
          path: path,
          isOutline: false,
          borderWeight: 4, // 线条宽度，默认为 1
          strokeColor: color, // 线条颜色
          lineJoin: "round", // 折线拐点连接处样式
        });
      });
    },

    // 添加设备点标记点
    addPointMarkers() {
      let markerImage = [];
      for (let i = 0; i < data.pointMarkers.length; i++) {
        markerImage.push(data.pointMarkers[i].markerImage);
        var myIcon = new AMap.Icon({
          size: new AMap.Size(26, 32),
          image: require("@/assets/images/geological/" + markerImage[i]),
          imageSize: new AMap.Size(26, 32),
          // 图标取图偏移量
        });
        this.markerPoint = new AMap.Marker({
          icon: myIcon,
          anchor: "bottom-center",
          position: data.pointMarkers[i].location,
          offset: new AMap.Pixel(0, 5), // 设置点标记偏移量
        });
        // 保存具体监测点信息
        this.markerPoint.content = data.pointMarkers[i];
        // 给每个具体的监测点绑定监听点击事件
        AMap.event.addListener(this.markerPoint, "click", (e) => {
          this.listObj = e.target.content;
          // // 点击显示标记点选中状态
          // this.markerPoint.setPosition(e.target.content.location);
          // this.map.add(this.markerPoint);
          this.pointInfoWindow = new AMap.InfoWindow({
            anchor: "bottom-center",
            isCustom: true,
            showShadow: true,
            closeWhenClickMap: true, // 控制是否在鼠标点击地图后关闭信息窗体，默认false，鼠标点击地图后不关闭信息窗体
            content: this.$refs.pointInfoWindow,
            offset: new AMap.Pixel(0, -30),
            retainWhenClose: true,
          });
          this.showInfoWindow = true;
          this.pointInfoWindow.open(this.map, e.target.content.location);
        });
        this.markerPointAll.push(this.markerPoint);
      }
    },
    noticeBaseMap() {
      console.log("baseMap");
      this.satellite.hide();
      this.map.setMapStyle("amap://styles/normal");
      this.isActive = false;
    },
    noticeSatelliteMap() {
      // console.log("satelliteMap");
      // this.map.add(this.satellite);
      this.satellite.show();
      this.isActive = true;
    },
    initMap() {
      this.map = new AMap.Map("mapBox", {
        resizeEnable: true,
        zoom: 16,
        zooms: [3, 20],
        expandZoomRange: true,
      });
      // 初始化卫星图层
      this.satellite = new AMap.TileLayer.Satellite({
        map: this.map,
      });
      this.baseMap = new AMap.Map("baseMap", {
        doubleClickZoom: false,
        resizeEnable: false,
        dragEnable: false,
        zoom: 14,
        zooms: [3, 20],
        expandZoomRange: false,
        mapStyle: "amap://styles/normal",
      });
      this.satelliteMap = new AMap.Map("satelliteMap", {
        doubleClickZoom: false,
        resizeEnable: false,
        dragEnable: false,
        zoom: 14,
        zooms: [3, 20],
        expandZoomRange: false,
        layers: [new AMap.TileLayer.Satellite()],
      });
      // 初始化人行路线规划插件
      AMap.plugin("AMap.Driving", () => {
        //异步加载插件
        this.crossingDriving = new AMap.Driving({
          policy: AMap.DrivingPolicy.LEAST_TIME, // 根据起始点坐标规划路线
          hideMarkers: true, // 隐藏起点和终点的默认图标
          isOutline: false, // 是否显示路线描边
          autoFitView: true, //视线范围内
        });
      });
      // 初始化车辆路线规划插件
      AMap.plugin("AMap.Driving", () => {
        //异步加载插件
        this.vehicleDriving = new AMap.Driving({
          policy: AMap.DrivingPolicy.LEAST_TIME, // 根据起始点坐标规划路线
          hideMarkers: true, // 隐藏起点和终点的默认图标
          isOutline: false, // 是否显示路线描边
          autoFitView: true, //视线范围内
        });
      });

      // scale 比例尺
      AMap.plugin(["AMap.Scale"], () => {
        this.scale = new AMap.Scale({
          visible: true,
        });
        this.map.addControl(this.scale);
      });



      
    },
  },
};
</script>

<style lang="scss" scoped>
.pollingTrack-container {
  #mapBox {
    width: 100%;
    height: 80vh;
  }
  .thumbnail-container {
    position: absolute;
    right: 20px;
    bottom: 20px;
    display: flex;
    font-size: 12px;
    color: #fff;
    #baseMap,
    #satelliteMap {
      width: 100px;
      height: 70px;
      border: 1px solid #337ad1;
    }
    #baseMap {
      margin-right: 10px;
    }
    .description {
      position: absolute;
      right: 112px;
      bottom: 0;
      width: 40px;
      display: flex;
      justify-content: center;
      background: #3385ff;
    }
    .descriptions {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 40px;
      display: flex;
      justify-content: center;
      background: #3385ff;
    }
  }
  .pollingTrack-menu {
    position: absolute;
    top: 50px;
    left: 10px;
    line-height: 40px;
    color: #000;
    display: flex;
    z-index: 999;
    .track-menu {
      margin-right: 20px;
      background: #fff;
      border: 1px solid rgba(121, 121, 121, 0.4);
      border-radius: 6px;
      padding: 0 60px 0 20px;
    }
    .track-show {
      width: 630px;
      background: #fff;
      border: 1px solid rgba(121, 121, 121, 0.4);
      border-radius: 6px;
      padding: 0 60px 0 20px;
      display: flex;
      .menu {
        display: flex;
        align-items: center;
        margin-right: 20px;
        .tag {
          display: inline-block;
          width: 20px;
          height: 24px;
          background-image: url("../assets/images/geological/accelerograph.png");
          background-size: 20px 24px;
          background-repeat: no-repeat;
          background-position: center;
          margin-right: 5px;
        }
        .tag-lineY {
          width: 24px;
          height: 4px;
          background: #ff7800;
          margin-right: 10px;
        }
        .tag-lineB {
          width: 24px;
          height: 4px;
          background: #00f2ff;
          margin-right: 10px;
        }
      }
    }
  }

  .pointInfoWindow {
    width: 300px;
    font-size: 14px;
    color: #333;
    background: #fff;
    opacity: 0.9;
    border-radius: 4px;
    .pointInfo-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 24px;
      font-weight: 600;
      padding: 0 10px;
      background: #f2f2f2;
    }
    .pointInfo-content {
      padding: 10px;
      .el-row {
        height: 20px;
        line-height: 20px;
      }
    }
    // .pointInfo-footer {
    //   padding: 10px;
    //   border-top: 1px solid #ccc;
    // }
    // 三角形
    .delta {
      position: absolute;
      left: calc(50% - 8px);
      bottom: 0;
      width: 0;
      height: 0;
      border-top: 10px solid #fff;
      border-right: 8px solid transparent;
      border-left: 8px solid transparent;
    }
  }

  .active ::v-deep .amap-scale-text {
    color: #fff;
  }

  // 修改复选框样式
  // ::v-deep .el-checkbox .is-checked .el-checkbox__inner {
  //   background-color: #767676;
  //   border: 1px solid #767676;
  // }
  // ::v-deep .el-checkbox .is-checked .el-checkbox__inner::after {
  //   border-color: #fff;
  // }
  // ::v-deep .el-checkbox__inner:hover {
  //   border-color: #767676;
  // }
  // ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  //   color: #000;
  // }
  // ::v-deep .el-checkbox .is-checked .el-checkbox__inner span {
  //   color: #767676;
  // }
}
</style>
